import styled from 'styled-components'

import { DropzoneWithUrlV2Unstyled } from './unstyled'

export const DropzoneWithUrlV2 = styled(DropzoneWithUrlV2Unstyled)`
  img {
    display: inline-block;
  }
`
